const carManagement = {
  bindingCar: "Binding vehicles",
  noBindOBD: "please select the OBD code",
  speeding: "Speeding",
  sharpturn: "Sharp turn",
  emergencyBrake: "Emergency brake",
  rapidAcceleration: "Rapid acceleration",
  timeOfAppointment: "Time of appointment",
  vehicleUser: "Vehicle user",
  score: "Total Score",
  mileage: "Total Mileage",
  hour: "Total Time",
  bindingState: "Bind Status",
  brand: "Brand",
  model: "Model",
  maxSpeed: "Max speed",
  dutystatus: "Duty status",
  category: "Category",
  area: "Province",
  fuelType: "Fuel type",
  authorize: "Authorized to",
  successfulVerification: "Successful verification",
  message: {
    needchange: "Other vehicles are bound to this OBD. Do you want to change the binding?",
    deleteBind: "Bound vehicles cannot be deleted",
    noPermission: "You have no right to change the car information"
  },
  Unbound: "Unbind",
  binding: "Bind",
  untyTips: "Whether unbound or not ",
  createTime: "Create time",
  notOBD: "The vehicle is not bound to OBD",
  bindsuccess: "Binding successfully ",
  untysuccess: "Untying successfully",
  belong: "Belong",
  personal: "Personal",
  vinno: "VIN number",
  transmitterNumber: "Engine no",
  series: "Series",
  boundHistory: "Bind History",
  queryWidth: "260",
  tableWidth: {
    licensePlate: "160",
    areaName: "120",
    brandName: "90",
    seriesName: "100",
    modelName: "90",
    barCode: "110",
    carTerminalStatus: "120",
    isPrivate: "100",
    realName: "110",
    cartype: "120",
    authorize: "150"
  },
  createAndUpdate: {
    title1: "Vehicle information",
    title2: "Owner information",
    title3: "Device Information",
    title4: "Other information",
    permanent: "Permanent",
    temporary: "Temporary",
    create: "Add new vehicle",
    update: "Edit vehicle",
    category: "Category",
    vehicleowner: "Owner",
    leftLabelWidth: "100px",
    rightLabelWidth: "100px",
    error: {
      area: "Please select the vehicle area",
      category: "Please select the vehicle configuration",
      owner: "Please select the owner",
      licenseplate: "Please input the license plate"
    },
    selectTerminal: {
      title: "Double-click to select the OBD code",
      message: "The terminal doesn't have SIM card",
      tabelWidth1: "100px",
      tabelWidth2: "110px"
    }
  },
  history: {
    title: "View the binding history"
  },
  details: {
    licenseMessage: "(A red bottom represents a temporary licence)"
  },
  tips: "Untie the vehicle",
  noComments: "Please enter the reason",
  errorComments: "Remark length is within 1-250",
  buttonLabelWidth: "120px",
  regVin: "Reg.VIN#",
  ecuVin: "ECU VIN#",
  ecuVinRefreshTime: "Refresh Time",
  count: {
    total: "Total vehicle",
    binding: "Total binding",
    unbinding: "Total unbinding"
  },
  company: "Company",
  subCompany: "Sub Company",
  department: "Department",
  operate: {
    open: "On",
    close: "Off",
    unlock: "Unlock",
    atresia: "Atresia",
    pending: "Pending",
    width: '370px',
    tboxwidth: '460px',
    success: 'Command issued successfully',
    operateTip: "Are you sure to issue the command?",
    unlockTip: "Are you sure to unlock of",
    atresiaTip: "Are you sure to atresia of",
    inputTip: "Please input your password",
  }
}
export default carManagement